import React, { Children } from 'react';
import { motion } from 'framer-motion';
const bonuses = ['Guía de actividades offline según edad', 'Rutina familiar anti-pantallas', 'Plan de desconexión progresiva (paso a paso)', 'Checklist de límites saludables', 'Recursos prácticos para aplicar desde el día 1'];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    x: -15
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.4,
      ease: 'easeOut'
    }
  }
};
export function BonusSection() {
  return <section className="w-full bg-warm-white py-16 px-6" data-id="element-17">
      <div className="max-w-2xl mx-auto text-center" data-id="element-18">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.5
      }} className="font-playfair text-2xl md:text-3xl font-bold text-dark-text mb-10" data-id="element-19">
          BONUS INCLUIDOS
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="mb-10" data-id="element-20">
          <img src="https://cdn.magicpatterns.com/uploads/7zz2nx6omaSft9sycjz22k/ChatGPT_Image_26_ene_2026,_19_36_54.png" alt="5 Bonos incluidos con la compra del ebook" className="mx-auto max-w-full w-full h-auto rounded-lg shadow-lg" data-id="element-21" />
        </motion.div>

        <motion.ul variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="space-y-3 text-left max-w-md mx-auto" data-id="element-22">
          {bonuses.map((bonus, index) => <motion.li key={index} variants={itemVariants} className="font-lato text-base md:text-lg text-dark-text flex items-start gap-3" data-id="element-23">
              <span className="text-mint text-lg" data-id="element-24">✔️</span>
              <span data-id="element-25">{bonus}</span>
            </motion.li>)}
        </motion.ul>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.6
      }} className="font-lato text-sm text-medium-text mt-8" data-id="element-26">
          Todo incluido. Sin costos extra.
        </motion.p>
      </div>
    </section>;
}